import { render, staticRenderFns } from "./AutomaticRulesGrid.vue?vue&type=template&id=18116121&scoped=true&"
import script from "./AutomaticRulesGrid.vue?vue&type=script&lang=ts&"
export * from "./AutomaticRulesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AutomaticRulesGrid.vue?vue&type=style&index=0&id=18116121&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18116121",
  null
  
)

export default component.exports